export const TITLE_FONT_AWESOME = {
  PERSON: "user",
  DATE: "calendar-alt",
  LOCATION: "map-marker-alt",
  CUSTOM: "pen",
  EMAIL: "at",
  CURRENCY: "money-bill-wave",
  PERIOD: "hourglass-half",
  ORGANIZATION: "briefcase",
  NUMBER: "list-ol",
  MOBILE: "phone-alt",
  PINCODE: "map-marker-alt",
  URL: "globe",
};

export const getTitleFont = title => {
  // title must be in lowercase
  if (title.includes("person") || title.includes("name")) {
    return TITLE_FONT_AWESOME.PERSON;
  }
  if (title.includes("date")) {
    return TITLE_FONT_AWESOME.DATE;
  }
  if (title.includes("period")) {
    return TITLE_FONT_AWESOME.PERIOD;
  }
  return TITLE_FONT_AWESOME[title.toUpperCase()] || TITLE_FONT_AWESOME.CUSTOM;
};

export const clauseTypes = [
  {
    id: "type-1",
    title: "Full document review",
    description:
      "Algorithmically review the entire document, highlight key terms and classify document clauses into categories",
    icon: "file-alt",
    department: "Full",
  },
  {
    id: "type-2",
    title: "Product or service review",
    description:
      "Review and analyze information about the offerings such as the use of service and product specific compliance",
    icon: "shapes",
    department: "Product",
  },
  {
    id: "type-3",
    title: "Finance review",
    description:
      "Review and analyze the pricing information and all other financials in your document",
    icon: "sack-dollar",
    department: "Finance",
  },
  {
    id: "type-4",
    title: "Sales review",
    description:
      "Review and analyze the basic details like parties involved, terms of agreement, or a deal specific compliance which are essential in a document",
    icon: "badge-percent",
    department: "Sales",
  },
  {
    id: "type-5",
    title: "Legal review",
    description:
      "Review, analyze, and validate the legal obligations in your document for availing or offering specific products and services.",
    icon: "balance-scale",
    department: "Legal",
  },
];

export const spotlight = {
  id: "type-6",
  title: "In the spotlight",
  description:
    "Spotlight emphasizes the crucial parts in a business document from the numerous clause types that get tagged in Document Review.",
  icon: "flashlight",
  department: "Spotlight",
};

export const departmentIconMapping = {
  Legal: "balance-scale",
  Sales: "badge-percent",
  Finance: "sack-dollar",
  Product: "shapes",
  Full: "file-alt",
};

export const tagDescriptionMapping = {
  "Representations & Warranty":
    "It provides details of assertion & assurance of facts which a party is expected to rely upon while entering into the agreement.",
  Recitals:
    "It preceeds the main text in a contract and provides a general overview on the purpose of contract, the parties & effective date. It is an introduction to the contract.",
  Definition:
    "Defines the key terms used in the contacts for common understanding.",
  Liability:
    "This specifies the limitation on damages that one party is obligated to pay the other under specific circumstances as agreed in the contract",
  Indemnification:
    "It defines the responsibility of the service provider to bear customer's or vendor's cost and/or expenses as a result of a claim by a third party due to certain event",
  Insurance:
    "It describes the requirement of Insurance coverage for Employee, Office, Commercial general liability and Professional liability.",
  Disclaimers:
    "It is a statement that denies or restricts the responsibility or liability of a party. ",
  "Data Privacy":
    "It describes the practices to ensure that customers' data is only used for its intended purpose.",
  "Data Security":
    "It talks about how the data (personal and non-personal) is protected, encrypted, shared, and secured regarding confidentiality, integrity & accountability.",
  Confidentiality:
    "It is an agreement between the parties to not disclose any information shared or provided by each other during the contract term",
  "Term - Termination":
    "It is a written provision in an agreement that defines the circumstances under which the agreement can be terminated and the effects of such termination.",
  Renewal:
    "It provides details about the contract/agreement renewal (auto or mutual)",
  "Dispute Resolution":
    "It sets out the process by which the parties intend to resolve any disputes which may arise out of their contract.",
  "Pricing - Fees - Payments & Taxation":
    "It provides details about expected schedule and method of payment for the services offerred ",
  "Intellectual Property Rights":
    "It handles all intellectual property ownership related to the agreement or license, including each party's pre-existing intellectual property.",
  "Use of Services":
    "It defines the rights and responsibilites associated with the services offered to the user. This also includes the details on the license software",
  Compliance:
    "It provides details on requirements arising from specific laws, policies and/or standards. ",
  "Provision of Services":
    "It provides details on the scope of work which includes the delivery, installation, acceptance & maintenance of product/service offerred from vendor/ licensor /service provider.",
  Audit:
    "It provides details on audit requirement, process & responsibilities.",
  Publicity:
    "It provides details on party's rights on Marketing, usage of brand/name, logo and trademark.",
  Personnel:
    "It provides details on requirement & process of background check/ screening of employees of either party.",
  Miscellaneous:
    "It lists the ancillary and incidental clauses mentioned in the contract",
};
